import { useSelectedPaymentInformation } from "@apac/checkout";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { CardTypeCollection } from "@hopper-b2b/types";
import styles from "./styles.module.scss";

interface PaymentMethodProps {
  displayName?: string;
}

export const PaymentMethod = ({ displayName }: PaymentMethodProps) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "PaymentMethod");

  const selectedPayment = useSelectedPaymentInformation();
  const cardName =
    displayName ?? CardTypeCollection[selectedPayment?.cardType ?? ""];

  if (!selectedPayment) {
    return null;
  }

  return (
    <div className={block}>
      <div className={cn("container")}>
        <div className={cn("card-name")}>{t("paymentMethod")}</div>
        <div className={cn("card-value")}>
          <span>{cardName}</span>
          <span>{`**** ${selectedPayment.last4}`}</span>
        </div>
      </div>
    </div>
  );
};
